import { useIsMobileSearchV2Enabled } from '#/layouts/Layout/Header/MobileSearchV2/useIsMobileSearchV2Enabled';

// (adding this to communicate/be explicit that these are 2 different features
// relying on the same flag, see the story for more details)
export function useIsHamburgerMenuEnabled(): boolean {
  return useIsMobileSearchV2Enabled();
}
